import React, { createContext, useContext, useEffect, useState, useRef } from 'react';

const SidebarContext = createContext(null);

const STORAGE_KEY = 'canales_sidebar_collapsed';
const AUTO_COLLAPSE_PX = 1280;  // Iter 77 — auto-collapse below xl

export function SidebarProvider({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  // Tracks whether the current collapse was triggered automatically by the
  // viewport size; we want to RESTORE the user's preferred state when they
  // resize back up to a wide window.
  const userPrefRef = useRef(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      userPrefRef.current = v === '1';
    } catch { /* ignore */ }

    const apply = () => {
      const tooNarrow = typeof window !== 'undefined' && window.innerWidth < AUTO_COLLAPSE_PX;
      // Final state: forced narrow OR explicit user preference.
      setCollapsed(tooNarrow || userPrefRef.current);
    };
    apply();
    window.addEventListener('resize', apply);
    return () => window.removeEventListener('resize', apply);
  }, []);

  const toggle = () => {
    setCollapsed((v) => {
      const next = !v;
      userPrefRef.current = next;
      try { localStorage.setItem(STORAGE_KEY, next ? '1' : '0'); } catch { /* ignore */ }
      return next;
    });
  };

  return (
    <SidebarContext.Provider value={{ collapsed, toggle }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const ctx = useContext(SidebarContext);
  if (!ctx) return { collapsed: false, toggle: () => {} };
  return ctx;
}
